var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { publishToModules, subscribe, unsubscribe } from "./messageBus";
import { getValidatedParameters, getGameRefParameter, getParameter } from "./getParameter";
const gameFrame = document.getElementById("game");
let cachedLaunchConfig = { url: "" };
let gameUrlResolve = undefined;
const setLaunchParameters = (payload) => {
    cachedLaunchConfig = Object.assign(Object.assign({}, cachedLaunchConfig), payload);
};
subscribe("nx-set-launch-parameters", setLaunchParameters);
export const prepareGameFrame = (layerConfig) => {
    var _a;
    if (layerConfig.allowGameFrameScrolling === true) {
        gameFrame.removeAttribute("scrolling");
        (_a = document.getElementById("minimal-ui-treadmill")) === null || _a === void 0 ? void 0 : _a.remove();
    }
    if (layerConfig.allowClipboardWrite === true) {
        const allowList = layerConfig.gameOrigin !== undefined ? ` ${layerConfig.gameOrigin}` : "";
        gameFrame.allow = `clipboard-write${allowList}`;
    }
};
export const prepareGameUrl = () => {
    var _a;
    cachedLaunchConfig = {
        url: (_a = getParameter("gameurl")) !== null && _a !== void 0 ? _a : ""
    };
    if (!cachedLaunchConfig.url) {
        gameFrame.onload = () => {
            gameFrame.onload = null;
            cachedLaunchConfig.url = gameFrame.src;
            if (gameUrlResolve !== undefined) {
                gameUrlResolve({ url: "" });
            }
        };
        subscribe("nx-launch-game", function onGameLaunch(payload) {
            cachedLaunchConfig = Object.assign(Object.assign({}, cachedLaunchConfig), payload);
            if (!cachedLaunchConfig.url) {
                return;
            }
            if (gameUrlResolve !== undefined) {
                gameUrlResolve(payload);
            }
            unsubscribe(onGameLaunch);
            gameFrame.onload = null;
        });
    }
};
const getLaunchConfig = () => __awaiter(void 0, void 0, void 0, function* () {
    if (cachedLaunchConfig.url) {
        return cachedLaunchConfig;
    }
    return new Promise((resolve) => {
        gameUrlResolve = resolve;
    });
});
export const loadGame = (pathConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const launchConfig = yield getLaunchConfig();
    unsubscribe(setLaunchParameters);
    if (gameFrame.src) {
        return;
    }
    const parameters = getValidatedParameters();
    parameters.set("fullscreen", "false");
    parameters.delete("gameurl");
    parameters.delete("rciframeurl");
    if (process.env.MODE === "development") {
        parameters.delete("layerconfig");
    }
    if (parameters.get("channel") === "mobile-iosapp" && pathConfig.clientconfigurl !== undefined) {
        parameters.set("configurl", pathConfig.clientconfigurl);
    }
    for (const key in launchConfig.parameters) {
        const value = launchConfig.parameters[key];
        if (value === null) {
            parameters.delete(key);
        }
        else {
            parameters.set(key, (_a = launchConfig.parameters[key]) !== null && _a !== void 0 ? _a : "");
        }
    }
    if (process.env.TARGET === "ios_bundle") {
        parameters.set("gamelocation", launchConfig.url);
        const gameRef = (_b = getGameRefParameter()) !== null && _b !== void 0 ? _b : "";
        if (gameRef.startsWith("rlx.") && pathConfig.gamelauncher !== undefined) {
            launchConfig.url = pathConfig.gamelauncher;
        }
    }
    return new Promise((resolve, reject) => {
        var _a;
        gameFrame.onerror = () => {
            reject();
        };
        subscribe("game-load-loaded", function onGameLoaded() {
            resolve();
            unsubscribe(onGameLoaded);
        });
        gameFrame.src = `${launchConfig.url}?${parameters.toString()}`;
        void publishToModules("nx-game-frame-load-started", { gameId: (_a = parameters.get("gameid")) !== null && _a !== void 0 ? _a : "" });
    });
});
